import { render, staticRenderFns } from "./ResetPasswordSuccess.vue?vue&type=template&id=45386b86"
import script from "./ResetPasswordSuccess.vue?vue&type=script&lang=js"
export * from "./ResetPasswordSuccess.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordSuccess.vue?vue&type=style&index=0&id=45386b86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports